// Types
import { RootState } from 'types/RootState.types';

// Config
import deliveryConstants from '@constants/deliveryConstants';

export function shouldShowThresholdBar(state: RootState) {
  const {
    app: {
      isExpressCheckout = false,
    } = {},
    delivery: {
      deliveries = [],
      items = [],
    } = {},
  } = state ?? {};

  if (isExpressCheckout) {
    return false;
  };

  const hasOutlet = deliveries?.some((delivery) => delivery.outlet);
  if (hasOutlet) {
    return false;
  };

  const isShipFromStore = items?.some(item => item.availability?.shipFromStore);
  if (isShipFromStore) {
    return false;
  };


  const isSingleBatchOneMan = deliveries.length === 1 && deliveries[0].type === deliveryConstants.ONE_MAN;

  return isSingleBatchOneMan;
};
